import React from 'react';
import { Result, Button } from 'antd';
  
import { Link } from '@nackle/biw-web-router';
import { PageContainer, PageContent } from 'app/components/common'; 
import { Translate } from '../../../services';
import { Routes } from '../../../navigation'; 
import { QuestionCircleOutlined } from '@ant-design/icons';
import './styles.less';

export const NotFoundPage = () => {

    return (
        <PageContent className="page-not-found">
            <PageContainer> 
                <Result 
                    icon={ <QuestionCircleOutlined /> }
                    title="404"
                    subTitle={ <Translate.Text value="page.notFound.description" /> }
                    extra={
                        <Link to={ Routes.Home.buildPath() }>
                            <Button>
                                <Translate.Text value="page.notFound.backToHome" />
                            </Button>
                        </Link>
                      }
                />
            </PageContainer>
        </PageContent>
    );
};

 